import { css } from 'styled-components';

export const AntdDropdownItemsStyles = css`
  // After making changes, you should refresh the page, as it is used in the global index file.

  .ant-select-dropdown {
    border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg0[3]};
    border-radius: 12px;
    transition: none;

    .rc-virtual-list-scrollbar {
      width: 4px !important;
    }

    .rc-virtual-list-scrollbar-thumb {
      background: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]} !important;
    }

    .rc-virtual-list-holder {
      max-height: 200px;
      overflow-y: hidden;
      transition: none;

      &::-webkit-scrollbar,
      &::-webkit-scrollbar-track-piece,
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: ${({ theme }): string => theme.admanColors!.gray.light.fg[0]};
      }
    }

    .ant-select-item {
      height: 40px;
      font-size: 14px;
      align-items: center;
      border-radius: 8px;
      transition: none;

      &.ant-select-item-option-active {
        background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg1[8]};
      }

      &.ant-select-item-option-selected {
        background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg[1]};
        font-weight: inherit;

        &:hover,
        &.ant-select-item-option-active {
          background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg[1]};
        }
      }
    }
  }

  // TreeSelect specific styles
  .ant-select-tree {
    .ant-select-tree-treenode {
      padding: 0;
      transition: none;

      &:hover {
        background-color: transparent;
      }

      .ant-select-tree-node-content-wrapper {
        border-radius: 8px;
        transition: none;
        padding: 4px 8px;

        &:hover {
          background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg1[8]};
        }

        &.ant-select-tree-node-selected {
          background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg[1]};
          font-weight: inherit;

          &:hover {
            background-color: ${({ theme }): string => theme.admanColors!.blue.light.bg[1]};
          }
        }
      }

      .ant-select-tree-checkbox {
        transition: none !important;

        &-inner {
          transition: none !important;

          &::after {
            transition: none !important;
          }
        }

        &-checked,
        &-indeterminate {
          .ant-select-tree-checkbox-inner {
            transition: none !important;

            &::after {
              transition: none !important;
            }
          }
        }
      }
    }
  }
`;
